export default __webpack_public_path__ + "static/media/GenomeBioExpo_TimeTable_20220729_en.0ba5004f.png";